/* =========================================================
   WABAAW HEADER — assets/wabaaw-header.js
   Original behavior, syntax-fixed
========================================================= */
(() => {
  const headers = document.querySelectorAll('[data-wabaaw-header]');
  if (!headers.length) return;

  headers.forEach((scope) => {
    // ============================
    // MENU
    // ============================
    (function initMenu() {
      const btn = scope.querySelector('.wabaaw-menu-btn');
      const overlay = scope.querySelector('.wabaaw-overlay');
      const drawer = scope.querySelector('.wabaaw-drawer');
      const closeEls = scope.querySelectorAll('[data-wabaaw-close]');
      if (!btn || !overlay || !drawer) return;

      let lastFocus = null;

      function lockPage(lock) {
        const sbw = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

        if (lock) {
          const y = window.scrollY || document.documentElement.scrollTop || 0;
          document.body.dataset.wabaawScrollY = String(y);
          document.body.style.position = 'fixed';
          document.body.style.top = `-${y}px`;
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
          document.body.style.paddingRight = sbw ? `${sbw}px` : '';
        } else {
          const y = parseInt(document.body.dataset.wabaawScrollY || '0', 10);
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          document.body.style.paddingRight = '';
          window.scrollTo(0, y);
        }
      }

      function openMenu() {
        lastFocus = document.activeElement;
        document.body.classList.add('wabaaw-menu-open');
        btn.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');

        const first = drawer.querySelector('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
        if (first) setTimeout(() => first.focus(), 30);

        lockPage(true);
      }

      function closeMenu() {
        document.body.classList.remove('wabaaw-menu-open');
        btn.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');

        lockPage(false);

        if (lastFocus && lastFocus.focus) {
          setTimeout(() => lastFocus.focus(), 10);
        }
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openMenu();
      });

      overlay.addEventListener('click', closeMenu);
      closeEls.forEach((el) => el.addEventListener('click', closeMenu));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('wabaaw-menu-open')) {
          closeMenu();
        }
      });
    })();

    // ============================
    // SEARCH
    // ============================
    (function initSearch() {
      const openBtn = scope.querySelector('.wabaaw-search-btn');
      const searchOverlay = scope.querySelector('.wabaaw-search-overlay');
      const panel = searchOverlay ? searchOverlay.querySelector('.wabaaw-search-panel') : null;
      const input = searchOverlay ? searchOverlay.querySelector('.wabaaw-search-input') : null;
      const results = searchOverlay ? searchOverlay.querySelector('.wabaaw-search-results') : null;
      const resultsWrap = searchOverlay ? searchOverlay.querySelector('.wabaaw-search-results-wrap') : null;
      const closeBtn = searchOverlay ? searchOverlay.querySelector('.wabaaw-search-close') : null;
      if (!openBtn || !searchOverlay || !panel || !input || !results || !resultsWrap || !closeBtn) return;

      if (searchOverlay.parentElement !== document.body) {
        document.body.appendChild(searchOverlay);
      }

      let controller = null;
      let lastFocus = null;
      let t = null;
      const mqMobile = window.matchMedia('(max-width:760px)');
      let seeded = false;
      let cachedProducts = [];
      let isSearchOpen = false;
      let rafA = 0;
      let rafB = 0;
      let imagePreloadPromise = null;
      let searchWarmPromise = null;

      function getCurrency() {
        return (scope && scope.dataset && scope.dataset.currency) ? scope.dataset.currency : 'USD';
      }

      function lockPage(lock) {
        const sbw = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        if (lock) {
          const y = window.scrollY || document.documentElement.scrollTop || 0;
          document.body.dataset.wabaawScrollY = String(y);
          document.body.style.position = 'fixed';
          document.body.style.top = `-${y}px`;
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
          document.body.style.paddingRight = sbw ? `${sbw}px` : '';
        } else {
          const y = parseInt(document.body.dataset.wabaawScrollY || '0', 10);
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          document.body.style.paddingRight = '';
          window.scrollTo(0, y);
        }
      }

      function moneyFmt(value) {
        if (value == null) return '';
        const n = Number(value);
        if (Number.isFinite(n)) {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: getCurrency() }).format(n);
        }
        return String(value);
      }

      function shuffle(arr) {
        const a = arr.slice();
        for (let i = a.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
      }

      function removeRecommendedHeading() {
        searchOverlay.querySelectorAll('.wabaaw-search-rec-title').forEach((el) => el.remove());

        const maybe = panel.querySelectorAll('h1,h2,h3,h4,div,span');
        maybe.forEach((el) => {
          const txt = (el.textContent || '').trim().toLowerCase();
          if (txt === 'recommended items') el.remove();
        });
      }

      function normalizeImageUrl(url, width = 600) {
        if (!url) return '';
        try {
          const u = new URL(url, window.location.origin);
          u.searchParams.set('width', String(width));
          return u.toString();
        } catch (e) {
          const joiner = url.includes('?') ? '&' : '?';
          return `${url}${joiner}width=${width}`;
        }
      }

      function preloadImage(url) {
        return new Promise((resolve) => {
          if (!url) return resolve();
          const img = new Image();
          img.decoding = 'async';
          img.fetchPriority = 'high';
          img.onload = () => resolve();
          img.onerror = () => resolve();
          img.src = url;
          if (img.complete) resolve();
        });
      }

      function preloadProductsImages(items, eagerCount) {
        const list = (items || [])
          .map((p) => p && p.image ? normalizeImageUrl(p.image, mqMobile.matches ? 480 : 600) : '')
          .filter(Boolean)
          .slice(0, eagerCount);

        return Promise.all(list.map(preloadImage));
      }

      function renderGrid(items) {
        results.innerHTML = '';
        if (!items || !items.length) return;

        items.forEach((p, index) => {
          const a = document.createElement('a');
          a.href = p.url || '#';

          const imgWrap = document.createElement('div');
          imgWrap.className = 'wabaaw-s-img';

          if (p.image) {
            const img = document.createElement('img');
            const finalSrc = normalizeImageUrl(p.image, mqMobile.matches ? 480 : 600);
            img.loading = index < 4 ? 'eager' : 'eager';
            img.decoding = 'async';
            img.fetchPriority = index < 4 ? 'high' : 'auto';
            img.alt = p.title || '';
            img.src = finalSrc;
            img.width = 600;
            img.height = 600;
            imgWrap.appendChild(img);
          }

          const meta = document.createElement('div');
          meta.className = 'wabaaw-s-text';

          const title = document.createElement('div');
          title.className = 'wabaaw-s-title';
          title.textContent = (p.title || '').trim();

          const price = document.createElement('div');
          price.className = 'wabaaw-s-price';
          price.textContent = p.price ? p.price : '';

          meta.appendChild(title);
          if (p.price) meta.appendChild(price);

          a.appendChild(imgWrap);
          a.appendChild(meta);

          results.appendChild(a);
        });
      }

      async function fetchRandomProducts() {
        try {
          const r = await fetch('/products.json?limit=60', { headers: { Accept: 'application/json' } });
          const data = await r.json();
          const products = Array.isArray(data && data.products) ? data.products : [];
          const mapped = products
            .filter((p) => p && p.title && p.handle)
            .map((p) => {
              const img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
              const price = (p.variants && p.variants[0] && p.variants[0].price) ? p.variants[0].price : '';
              return { title: p.title, url: '/products/' + p.handle, image: img, price: price ? moneyFmt(price) : '' };
            });
          cachedProducts = mapped;
          return mapped;
        } catch (e) {
          return [];
        }
      }

      async function warmSearchProducts() {
        if (searchWarmPromise) return searchWarmPromise;
        searchWarmPromise = (async () => {
          if (!cachedProducts.length) {
            await fetchRandomProducts();
          }
          const eagerPool = shuffle(cachedProducts).slice(0, 12);
          imagePreloadPromise = preloadProductsImages(eagerPool, 12);
          await imagePreloadPromise;
        })();
        return searchWarmPromise;
      }

      async function seedRecommended() {
        if (seeded) return;
        seeded = true;

        removeRecommendedHeading();

        if (!cachedProducts.length) {
          await fetchRandomProducts();
        }

        const limit = mqMobile.matches ? 8 : 9;
        const picks = shuffle(cachedProducts).slice(0, limit);

        if (!imagePreloadPromise) {
          imagePreloadPromise = preloadProductsImages(picks, limit);
        }

        await imagePreloadPromise.catch(() => {});
        renderGrid(picks);
      }

      function primeSearchLayer() {
        searchOverlay.style.display = 'block';
        searchOverlay.style.visibility = 'hidden';
        searchOverlay.style.pointerEvents = 'none';
        searchOverlay.setAttribute('aria-hidden', 'true');

        const prevPanelOpacity = panel.style.opacity;
        panel.style.opacity = '0';

        void searchOverlay.offsetHeight;
        void panel.offsetHeight;
        void input.offsetHeight;

        panel.style.opacity = prevPanelOpacity;
        searchOverlay.style.display = '';
        searchOverlay.style.visibility = '';
        searchOverlay.style.pointerEvents = '';

        warmSearchProducts().catch(() => {});
      }

      function stabilizeSearchOpen() {
        searchOverlay.style.display = 'block';
        searchOverlay.style.visibility = 'hidden';
        searchOverlay.style.pointerEvents = 'none';
        searchOverlay.style.opacity = '0';
        panel.style.opacity = '0';

        void searchOverlay.offsetHeight;
        void panel.offsetHeight;
        void input.offsetHeight;

        rafA = requestAnimationFrame(() => {
          rafB = requestAnimationFrame(() => {
            if (!isSearchOpen) return;

            searchOverlay.style.display = '';
            searchOverlay.style.visibility = '';
            searchOverlay.style.pointerEvents = '';
            searchOverlay.style.opacity = '';
            panel.style.opacity = '';

            document.body.classList.add('wabaaw-search-open');
            document.documentElement.classList.add('wabaaw-search-open');
            openBtn.setAttribute('aria-expanded', 'true');
            searchOverlay.setAttribute('aria-hidden', 'false');

            searchOverlay.scrollTop = 0;
          });
        });
      }

      async function openSearch() {
        if (isSearchOpen) return;
        isSearchOpen = true;

        lastFocus = document.activeElement;

        input.blur();
        input.value = '';
        results.innerHTML = '';
        seeded = false;

        removeRecommendedHeading();

        if (controller) controller.abort();
        clearTimeout(t);

        lockPage(true);
        stabilizeSearchOpen();

        await warmSearchProducts().catch(() => {});
        await seedRecommended();

        setTimeout(() => {
          if (isSearchOpen) input.focus({ preventScroll: true });
        }, 120);
      }

      function closeSearch() {
        if (!isSearchOpen) return;
        isSearchOpen = false;

        cancelAnimationFrame(rafA);
        cancelAnimationFrame(rafB);

        document.body.classList.remove('wabaaw-search-open');
        document.documentElement.classList.remove('wabaaw-search-open');
        openBtn.setAttribute('aria-expanded', 'false');
        searchOverlay.setAttribute('aria-hidden', 'true');

        searchOverlay.style.display = '';
        searchOverlay.style.visibility = '';
        searchOverlay.style.pointerEvents = '';
        searchOverlay.style.opacity = '';
        panel.style.opacity = '';

        lockPage(false);

        results.innerHTML = '';
        input.value = '';
        seeded = false;
        imagePreloadPromise = null;

        removeRecommendedHeading();

        if (controller) controller.abort();
        clearTimeout(t);

        warmSearchProducts().catch(() => {});

        openBtn.blur();
        if (lastFocus && lastFocus.focus) setTimeout(() => lastFocus.focus(), 10);
      }

      openBtn.addEventListener('pointerenter', () => {
        warmSearchProducts().catch(() => {});
      }, { passive: true });

      openBtn.addEventListener('touchstart', () => {
        warmSearchProducts().catch(() => {});
      }, { passive: true });

      openBtn.addEventListener('focus', () => {
        warmSearchProducts().catch(() => {});
      });

      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openSearch();
      });

      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeSearch();
      });

      searchOverlay.addEventListener('click', (e) => {
        if (e.target === searchOverlay) closeSearch();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isSearchOpen) closeSearch();
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') e.preventDefault();
      });

      input.addEventListener('input', () => {
        const q = input.value.trim();
        if (controller) controller.abort();

        if (q.length < 2) {
          seeded = false;
          imagePreloadPromise = null;
          removeRecommendedHeading();
          seedRecommended();
          return;
        }

        removeRecommendedHeading();

        clearTimeout(t);
        t = setTimeout(() => {
          controller = new AbortController();

          fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=12`, {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          })
            .then((r) => r.json())
            .then(async (data) => {
              if (!isSearchOpen) return;

              const products = (data && data.resources && data.resources.results && data.resources.results.products)
                ? data.resources.results.products
                : [];

              const byUrl = new Map(cachedProducts.map((p) => [p.url, p]));
              const byHandle = new Map(
                cachedProducts
                  .map((p) => {
                    const m = (p.url || '').match(/\/products\/([^/?#]+)/);
                    return m ? [m[1], p] : null;
                  })
                  .filter(Boolean)
              );

              const mapped = products.map((p) => {
                const url = (p && p.url) ? p.url : '';
                const handleMatch = url.match(/\/products\/([^/?#]+)/);
                const handle = handleMatch ? handleMatch[1] : '';
                const cached = byUrl.get(url) || (handle ? byHandle.get(handle) : null);

                const suggestImg =
                  (p && p.image) ||
                  (p && p.featured_image && (p.featured_image.url || p.featured_image)) ||
                  (p && p.images && p.images[0] && (p.images[0].url || p.images[0])) ||
                  '';

                const suggestPrice = (p && (p.price ?? p.price_min)) || '';

                return {
                  title: (p && p.title) ? p.title : (cached ? cached.title : ''),
                  url: url || (cached ? cached.url : '#'),
                  image: suggestImg || (cached && cached.image ? cached.image : ''),
                  price: (cached && cached.price) ? cached.price : (suggestPrice ? moneyFmt(suggestPrice) : '')
                };
              });

              const sliced = mapped.slice(0, mqMobile.matches ? 8 : 9);
              await preloadProductsImages(sliced, sliced.length);
              if (!isSearchOpen) return;
              renderGrid(sliced);
            })
            .catch(() => {});
        }, 140);
      });

      if (document.readyState === 'complete') {
        primeSearchLayer();
      } else {
        window.addEventListener('load', primeSearchLayer, { once: true });
      }

      window.addEventListener('pageshow', primeSearchLayer);
      window.addEventListener('resize', () => {
        if (!isSearchOpen) primeSearchLayer();
      });
    })();
  });
})();